import { InjectionToken } from '@angular/core';

export interface IMenuClickHandler {
  getCodes(): string[];
  execute(code: string, $event: MouseEvent): void;
}

export const MENU_CLICK_HANDLERS = new InjectionToken<IMenuClickHandler>('direct.menu.click.handlers');
